import { default as InputMultiSelect } from './InputMultiSelect';

export default InputMultiSelect;
